<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}"
                         icon="basicSettings" [active]="true">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="my-4">{{'lang.share.shareDetails' | translate}}</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                        <input type="text" id="Title" class="form-control"
                               formControlName="Name" sbAutofocus>
                        <span class="form-text text-muted">{{'lang.globals.nameDescription' | translate}}</span>
                        <div *ngIf="Name.touched && Name.errors?.required"
                             class="alert alert-danger">
                          {{'lang.globals.nameWarning' | translate}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
                        <input type="text" id="Description" class="form-control"
                               formControlName="Description">
                        <span class="form-text text-muted">{{'lang.globals.descriptionDescription'| translate}}</span>
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed">
                  <h3 class="my-4">{{'lang.globals.filters' | translate}}</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="wizard__forms__filterWrapper__filterStep">
                        <!--                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter">
<div class="wizard__forms__filterWrapper__filterStep__icon">
<fa-icon icon="calendar"></fa-icon>
</div>
</div>-->
                        <div *ngPermissions="[permissionService.Permission.cull_show]"
                             class="wizard__forms__filterWrapper">
                          <div class="wizard__forms__filterWrapper__filterStep">
                            <div
                              [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('ClientCull')}"
                              class="wizard__forms__filterWrapper__filterStep__singleFilter">
                              <div class="wizard__forms__filterWrapper__filterStep__icon">
                                <sb-icon [ngClass]="{'blue' : clientCull}"
                                         icon="companyClient">
                                </sb-icon>
                              </div>
                              <div
                                class="wizard__forms__filterWrapper__filterStep__label">
                                <h3 *ngIf="clientCull?.name">{{clientCull?.name}}</h3>
                                <label class="form-label">{{'lang.globals.clientFilter' | translate}}</label>
                              </div>
                              <div
                                class="wizard__forms__filterWrapper__filterStep__options">
                                <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                           (click)="changeWizardState('ClientCullSelect')"
                                           ngbTooltip="{{'lang.globals.selectFilter' | translate}}"
                                           placement="top" container="body"
                                           classes="btn-hover-primary m-0 green {{wizardState==='ClientCullSelect' ? 'btn-hover-primary--active' : ''}}">
                                  <sb-icon icon="list"></sb-icon>
                                </sb-button>
                                <span class="btn-separator">|</span>
                                <sb-button
                                  *ngIf="!clientCull && permissionService.hasPermissions([permissionService.Permission.cull_client_create])"
                                  (click)="changeWizardState('ClientCullEdit')"
                                  ngbTooltip="{{'lang.globals.createFilter' | translate}}"
                                  placement="top" container="body"
                                  classes="btn-hover-primary m-0 green {{wizardState==='ClientCullEdit' ? 'btn-hover-primary--active' : ''}}">
                                  <sb-icon icon="plus"></sb-icon>
                                </sb-button>
                                <sb-button
                                  *ngIf="clientCull && !clientCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_client_edit])"
                                  (click)="changeWizardState('ClientCullEdit')"
                                  ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}"
                                  placement="top" container="body"
                                  classes="btn-hover-primary {{wizardState==='ClientCullEdit' ? 'btn-hover-primary--active' : ''}}">
                                  <sb-icon icon="edit"></sb-icon>
                                </sb-button>
                                <sb-button *ngIf="clientCull"
                                           (click)="sliceCull($event, 'ClientCull')" container="body"
                                           ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}"
                                           placement="top" classes="btn-hover-primary m-0 red">
                                  <sb-icon icon="trash"></sb-icon>
                                </sb-button>
                              </div>
                            </div>
                          </div>
                          <div class="wizard__forms__filterWrapper__filterStep">
                            <div
                              [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('PlayerCull')}"
                              class="wizard__forms__filterWrapper__filterStep__singleFilter">
                              <div class="wizard__forms__filterWrapper__filterStep__icon">
                                <sb-icon [ngClass]="{'blue' : playerCull}" icon="playerOnline">
                                </sb-icon>
                              </div>
                              <div
                                class="wizard__forms__filterWrapper__filterStep__label">
                                <h3 *ngIf="playerCull?.name">{{playerCull?.name}}</h3>
                                <label class="form-label">{{'lang.globals.playerFilter' | translate}}</label>
                              </div>
                              <div
                                class="wizard__forms__filterWrapper__filterStep__options">
                                <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                           (click)="changeWizardState('PlayerCullSelect')"
                                           ngbTooltip="{{'lang.globals.selectFilter' | translate}}"
                                           placement="top" container="body"
                                           classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullSelect' ? 'btn-hover-primary--active' : ''}}">
                                  <sb-icon icon="list"></sb-icon>
                                </sb-button>
                                <span class="btn-separator">|</span>
                                <sb-button
                                  *ngIf="!playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                                  (click)="changeWizardState('PlayerCullEdit')"
                                  ngbTooltip="{{'lang.globals.createFilter' | translate}}"
                                  placement="top" container="body"
                                  classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                                  <sb-icon icon="plus"></sb-icon>
                                </sb-button>
                                <sb-button
                                  *ngIf="playerCull && !playerCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_player_edit])"
                                  (click)="changeWizardState('PlayerCullEdit')"
                                  ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}"
                                  placement="top" container="body"
                                  classes="btn-hover-primary {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                                  <sb-icon icon="edit"></sb-icon>
                                </sb-button>
                                <sb-button *ngIf="playerCull"
                                           (click)="sliceCull($event, 'PlayerCull')"
                                           ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}"
                                           container="body"
                                           placement="top" classes="btn-hover-primary m-0 red">
                                  <sb-icon icon="trash"></sb-icon>
                                </sb-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed">
                  <h3 class="my-4">{{'lang.globals.settings' | translate}}</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <sb-threeway-toggle-button
                          id="Bookable"
                          [model]="Bookable.value"
                          (modelChange)="Bookable.setValue($event)"
                        ></sb-threeway-toggle-button>
                        <label class="form-check-label ml-2" for="Bookable">{{'lang.networkShare.bookable' | translate}}</label>
                      </div>
                      <div class="form-group d-block">
                        <sb-threeway-toggle-button
                          id="Subletable"
                          [model]="Subletable.value"
                          (modelChange)="Subletable.setValue($event)"
                        ></sb-threeway-toggle-button>
                        <label class="form-check-label ml-2" for="Subletable">{{'lang.networkShare.subletable' | translate}}</label>
                      </div>
                      <div class="form-group d-block">
                        <sb-threeway-toggle-button
                          id="ShowOnlineStatus"
                          [model]="ShowOnlineStatus.value"
                          (modelChange)="ShowOnlineStatus.setValue($event)"
                        ></sb-threeway-toggle-button>
                        <label class="form-check-label ml-2"
                               for="ShowOnlineStatus">{{'lang.networkShare.showOnlineStatus' | translate}}</label>
                      </div>
                      <div class="form-group d-block">
                        <sb-threeway-toggle-button
                          id="ShowPlaylist"
                          [model]="ShowPlaylist.value"
                          (modelChange)="ShowPlaylist.setValue($event)"
                        ></sb-threeway-toggle-button>
                        <label class="form-check-label ml-2" for="ShowPlaylist">{{'lang.networkShare.showPlaylist' | translate}}</label>
                      </div>
                      <div class="form-group d-block">
                        <sb-threeway-toggle-button
                          id="ShowPlayouts"
                          [model]="ShowPlayouts.value"
                          (modelChange)="ShowPlayouts.setValue($event)"
                        ></sb-threeway-toggle-button>
                        <label class="form-check-label ml-2" for="ShowPlayouts">{{'lang.networkShare.showPlayouts' | translate}}</label>
                      </div>
                      <div class="form-group d-block">
                        <sb-threeway-toggle-button
                          id="ShowLogs"
                          [model]="ShowLogs.value"
                          (modelChange)="ShowLogs.setValue($event)"
                        ></sb-threeway-toggle-button>
                        <label class="form-check-label ml-2" for="ShowLogs">{{'lang.networkShare.showLogs' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group validateMe">
                        <label class="form-label" for="TemplateData">{{'lang.networkShare.templateData' | translate}}</label>
                        <select id="TemplateData" class="form-select" formControlName="AccessTemplateData">
                          <option
                            *ngFor="let accessOption of AccessOption | keyvalue"
                            [ngValue]="accessOption.value"
                            class="font-weight-bold">{{'lang.networkShare.accessOption.' + accessOption.value | translate}}</option>
                        </select>
                        <span class="form-text text-muted">{{'lang.networkShare.accessOptionDescription' | translate}}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Bookings">{{'lang.globals.bookings' | translate}}</label>
                        <select id="Bookings" class="form-select" formControlName="AccessBookings">
                          <option
                            *ngFor="let accessOption of AccessOption | keyvalue"
                            [ngValue]="accessOption.value"
                            class="font-weight-bold">{{'lang.networkShare.accessOption.' + accessOption.value | translate}}</option>
                        </select>
                        <span class="form-text text-muted">{{'lang.networkShare.accessOptionDescription' | translate}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!--<div class="row">
              <div class="col-md-12">
                <div class="form-group validateMe">
                  <label for="Level">{{'lang.globals.level' | translate}}</label>
                  <input type="number" id="Level" class="form-control"
                         formControlName="Level">
                  <span class="form-text text-muted">{{'lang.globals.levelDescription' |
                    translate}}</span>
                </div>
              </div>
            </div>-->
            <div class="row px-5">
              <div class="col-md-6">
                <div class="form-group validateMe">
                  <label class="form-label" for="Precondition">{{'lang.globals.precondition' | translate}}</label>
                  <select id="Precondition" class="form-select" [ngModel]="precondition"
                          (ngModelChange)="updatePrecondition($event)">
                    <option [ngValue]="null"
                            class="font-weight-bold">{{'lang.globals.noPrecondition'|translate}}</option>
                    <option *ngFor="let sched of shares"
                            [ngValue]="sched">{{sched.name}}</option>
                  </select>
                  <span class="form-text text-muted">{{'lang.globals.preconditionDescription' | translate}}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group validateMe">
                  <label class="form-label" for="Position">{{'lang.globals.position' | translate}}</label>
                  <select id="Position" class="form-select" [ngModel]="pickedPosition"
                          (ngModelChange)="updatePosition($event)">
                    <option *ngFor="let sched of preconditions"
                            [ngValue]="sched"
                            [ngClass]="{'font-weight-bold': sched?.id?.toString() === shareId?.toString()}">
                      {{sched?.id?.toString() === shareId?.toString() ? ('lang.globals.holdPosition' | translate) : sched.name}}</option>
                    <option [ngValue]="null"
                            class="font-weight-bold">{{'lang.globals.positionAtEnd'|translate}}</option>
                  </select>
                  <span class="form-text text-muted">{{'lang.globals.positionDescription' | translate}}</span>
                </div>
              </div>
            </div>
            <div class="wizard__footerActions px-5 pb-5">
              <button type="button" (click)="cancel()" class="btn btn-default btn-lg btn-wide">
                {{'lang.globals.cancel' | translate}}
              </button>
              <button (click)="submit()" [disabled]="!form.valid || loading"
                         class="btn btn-success btn-wide btn-lg">
                {{'lang.globals.submit' | translate}}
              </button>
            </div>
          </sb-wizard-tab>
          <div [@slideInOut] style="background-color: #f3f6f9;"
               class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column">
            <div *ngIf="wizardState!==''" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon icon="cancel" class="icon-in-btn mr-1"></sb-icon>
                {{'lang.globals.closeFilterSelection' | translate}}
              </button>
            </div>
            <filter-edit class="w-100 p-4" *ngIf="wizardState==='PlayerCullEdit'" [isInSidebarContext]=true
                         [cullId]="playerCull?.id" [type]="'PlayerCull'"
                         (submitSuccess)="filterSubmitSuccess($event)">
            </filter-edit>
            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='PlayerCullSelect'" preselectType="PlayerCull"
                                 (selectedFilter)="selectFilter($event)">
            </sb-page-filter-list>
            <filter-edit class="w-100 p-4" *ngIf="wizardState==='ClientCullEdit'" [isInSidebarContext]=true
                         [cullId]="clientCull?.id" [type]="'ClientCull'"
                         (submitSuccess)="filterSubmitSuccess($event)">
            </filter-edit>
            <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                 *ngIf="wizardState==='ClientCullSelect'" preselectType="ClientCull"
                                 (selectedFilter)="selectFilter($event)">
            </sb-page-filter-list>
            <div *ngIf="wizardState===''">
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
